export enum LocationSource {
    Server = 1,
    HomeWorkAreasSelector,
    SideWorkAreasSelector,
    MarketSelector,
}
